import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'logo-component',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo-component.html',
  styleUrl: './logo-component.scss'
})
export class LogoComponent implements OnInit{
  logoSrc: string = 'assets/images/mata-logo.svg'; // default

  ngOnInit() {
    // Example: In future, choose based on user/tenant/config/etc.
    const customLogo = this.getCustomLogo(); // you define this logic
    if (customLogo) {
      this.logoSrc = `assets/images/${customLogo}`;
    }
  }

  getCustomLogo(): string | null {
    // Placeholder logic; replace with real condition
    // e.g. from localStorage, config file, API response, etc.
    const useAltLogo = false;
    return useAltLogo ? 'alt-logo.svg' : null;
  }

}
